import { createSelector } from '@reduxjs/toolkit';

export const selectFormsSlice = (state) => state.forms;

export const selectFormsObject = createSelector([selectFormsSlice], (formsSlice) => formsSlice.forms);
export const selectSubmitFormInProgress = createSelector([selectFormsSlice], (formControlSlice) => formControlSlice.submitFormInProgress);
export const selectFormById = (id) => createSelector([selectFormsObject, (_, formId = id) => formId], (forms, formId) => forms[formId] || {});
